import React, { useState } from 'react';
import { createGlobalStyle } from 'styled-components';
import { isMobile } from 'react-device-detect';
import Swiper from 'react-id-swiper';
import { MainContainer } from '../../_components';
import { Block } from '../../components';
import DaysOfWeek from './components/DaysOfWeek';
import ScheduleGrid from '../../components/Schedule/components/ScheduleGrid';
import BarHeader from '../../components/Schedule/components/BarHeader';
import NavigationStatus from '../../components/Schedule/components/NavigationStatus';
import Datepicker from '../../components/Datepicker';
import Spinner from '../../components/Spinner';
import IDHelpers from '../../../core/helpers/IDHelper';
import Modal from '../../components/Modal';
import SectionHeader from '@/presentation/reusables/SectionHeader';

interface ScheduleViewProps {
  weeksByPeriod: any[];
  selectedDate: Date;
  today: Date;
  currentWeek: any;
  isCGT: boolean;
  dates: Date[];
  academicdates: any;
  meetings: any[];
  virtualMeetings: any[];
  slideDaySelected: any;
  isClass: boolean;
  isLoadingSchedule: boolean;
  handlerNext: (index: number) => void;
  handlerSelectDate: (date: Date) => void;
  slideChangeHandler: (swiper: any) => void;
  handleSelectAcademicCalendar: (academicDateId: number) => void;
  sectionHeader: any;
}

export const FixedMainLayoutStyles = createGlobalStyle`
   .cmpMainLayout {
    position: fixed;
  }
`;

const ScheduleView = (props: ScheduleViewProps) => {
  const {
    weeksByPeriod,
    selectedDate,
    today,
    isCGT,
    currentWeek,
    dates,
    academicdates,
    meetings,
    virtualMeetings,
    slideDaySelected,
    isClass,
    isLoadingSchedule,
    handlerNext,
    handlerSelectDate,
    slideChangeHandler,
    handleSelectAcademicCalendar,
    sectionHeader
  } = props;
  const [hasQueryCustom] = useState(false);
  const [dateQuery] = useState<any>('');

  const [isModalDetailOpen, setIsModalDetailOpen] = useState(false);
  const [contentModal, setContentModal]: any = useState(null);
  const handleCloseModalDetail = () => {
    setIsModalDetailOpen(false);
  };
  const handleOpenModalDetail = () => {
    setIsModalDetailOpen(true);
  };
  const handleContentModalDetail = (content: any) => {
    setContentModal(content);
  };

  const daysOfWeek = (
    <DaysOfWeek
      dates={dates}
      today={hasQueryCustom ? dateQuery : today}
      selectedDate={hasQueryCustom ? dateQuery : selectedDate}
      handleSelectDate={handlerSelectDate}
      // handleSelectMobileSlide={handlerSelectMobileSlide}
    />
  );
  const swiperItems = [
    <div
      className="slide-item"
      key={IDHelpers.generateID()}
      id={`${IDHelpers.generateID()}`}
    >
      {daysOfWeek}
    </div>
  ];
  return (
    <MainContainer>
      <SectionHeader
        title={sectionHeader.title}
        description={sectionHeader.description}
      />
      <Block
        flex
        style={{
          justifyContent: 'space-between',
          margin: isMobile ? '18px 0px 16px 0px' : '16px 0px 24px 0px'
        }}
      >
        {dates && (
          <>
            <Datepicker
              menu={weeksByPeriod}
              value={currentWeek?.id}
              handleSelectDate={handlerSelectDate}
              today={hasQueryCustom ? dateQuery : today}
              selectedDate={hasQueryCustom ? dateQuery : selectedDate}
              dates={dates}
              isCGT={isCGT}
            />
            <NavigationStatus
              onTodayButton={() => handlerNext(0)}
              onNextButton={() => handlerNext(1)}
              onPrevButton={() => handlerNext(-1)}
            />
          </>
        )}
      </Block>
      {!dates && <Spinner />}
      {dates && (
        <Block>
          {isMobile ? (
            <Swiper
              speed={200}
              resistance
              rebuildOnUpdate
              spaceBetween={40}
              cssMode={false}
              height={1700}
              initialSlide={0}
              runCallbacksOnInit={false}
              edgeSwipeDetection="prevent"
              loop
              slideToClickedSlide
              on={{
                slideChange: slideChangeHandler
              }}
            >
              {swiperItems}
            </Swiper>
          ) : (
            daysOfWeek
          )}
          <BarHeader
            virtualCourses={virtualMeetings}
            isClickOut={null}
            // dates={dates}
            ranges={academicdates}
            handleSelectRanges={handleSelectAcademicCalendar}
            selectedDate={hasQueryCustom ? dateQuery : selectedDate}
            isClass={isClass}
          />
          <ScheduleGrid
            isLoading={isLoadingSchedule}
            schedule={meetings}
            startHour={7}
            endHour={23}
            today={hasQueryCustom ? dateQuery : today}
            dates={dates}
            handleUpdateDropdown={handlerSelectDate}
            selectedDate={hasQueryCustom ? dateQuery : selectedDate}
            slideDaySelected={slideDaySelected}
            handleOpenModalDetail={handleOpenModalDetail}
            handleCloseModalDetail={handleCloseModalDetail}
            handleContentModalDetail={handleContentModalDetail}
          />
          {isModalDetailOpen && <FixedMainLayoutStyles />}
          <Modal
            IsModalOpen={isModalDetailOpen}
            handleCloseModal={handleCloseModalDetail}
          >
            {contentModal}
          </Modal>
        </Block>
      )}
    </MainContainer>
  );
};

export default ScheduleView;
